import { render, staticRenderFns } from "./AddNewPaygroup.vue?vue&type=template&id=4801dd56&scoped=true"
import script from "./AddNewPaygroup.vue?vue&type=script&lang=js"
export * from "./AddNewPaygroup.vue?vue&type=script&lang=js"
import style0 from "./AddNewPaygroup.vue?vue&type=style&index=0&id=4801dd56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801dd56",
  null
  
)

export default component.exports